export default __webpack_public_path__ + "static/media/fi-arrow-left.3fd39865.svg";